import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { CONTACT } from "./data";

const Shell = ({ title, children }) => (
  <div className="min-h-screen bg-[#fafafa] text-[#111]">
    <div className="brushed-metal grain text-white">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 pt-28 pb-14">
        <Link to="/" data-testid="legal-back" className="inline-flex items-center gap-2 font-grotesk text-sm text-neutral-300 hover:text-white transition-colors">
          <ArrowLeft size={16} /> Zurück zur Startseite
        </Link>
        <div className="mt-8 flex flex-col leading-none">
          <span className="font-display font-black text-4xl silver-text">P.M.R.</span>
          <span className="font-grotesk text-[10px] tracking-[0.32em] uppercase text-neutral-400 mt-1">Physio · Mobil · Roider</span>
        </div>
        <h1 className="mt-6 font-grotesk font-medium text-4xl sm:text-5xl tracking-tight">{title}</h1>
      </div>
    </div>
    <div className="max-w-3xl mx-auto px-5 sm:px-8 py-16 font-body text-[15px] leading-relaxed text-neutral-700 space-y-8">
      {children}
    </div>
  </div>
);

const H2 = ({ children }) => (
  <h2 className="font-grotesk font-semibold text-xl text-[#111] pt-2">{children}</h2>
);

export const Impressum = () => (
  <Shell title="Impressum">
    <section className="space-y-2">
      <H2>Angaben gemäß § 5 DDG</H2>
      <p>
        {CONTACT.name}<br />
        P.M.R. – Physio Mobil Roider<br />
        {CONTACT.street}<br />
        {CONTACT.city}
      </p>
    </section>

    <section className="space-y-2">
      <H2>Kontakt</H2>
      <p>
        Telefon: {CONTACT.phone}<br />
        E-Mail: {CONTACT.email}<br />
        Web: {CONTACT.web}
      </p>
    </section>

    <section className="space-y-2">
      <H2>Berufsbezeichnung und berufsrechtliche Regelungen</H2>
      <p>
        Berufsbezeichnung: Physiotherapeut (verliehen in der Bundesrepublik Deutschland).<br />
        Es gelten insbesondere das Masseur- und Physiotherapeutengesetz (MPhG) sowie die
        zugehörige Ausbildungs- und Prüfungsverordnung (PhysTh-APrV).
      </p>
      <p className="text-neutral-500 text-sm">
        [Bitte ergänzen: Umsatzsteuer-Identifikationsnummer gem. § 27a UStG bzw. Hinweis auf
        Kleinunternehmerregelung, falls zutreffend.]
      </p>
    </section>

    <section className="space-y-2">
      <H2>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</H2>
      <p>{CONTACT.name}, {CONTACT.street}, {CONTACT.city}</p>
    </section>

    <section className="space-y-2">
      <H2>Streitschlichtung</H2>
      <p>
        Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
        Verbraucherschlichtungsstelle teilzunehmen.
      </p>
    </section>

    <section className="space-y-2">
      <H2>Haftung für Inhalte</H2>
      <p>
        Als Diensteanbieter sind wir für eigene Inhalte auf diesen Seiten nach den allgemeinen
        Gesetzen verantwortlich. Wir sind jedoch nicht verpflichtet, übermittelte oder gespeicherte
        fremde Informationen zu überwachen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung
        von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.
      </p>
    </section>
  </Shell>
);

export const Datenschutz = () => (
  <Shell title="Datenschutzerklärung">
    <section className="space-y-2">
      <H2>1. Verantwortlicher</H2>
      <p>
        {CONTACT.name}<br />
        P.M.R. – Physio Mobil Roider<br />
        {CONTACT.street}, {CONTACT.city}<br />
        E-Mail: {CONTACT.email} · Telefon: {CONTACT.phone}
      </p>
    </section>

    <section className="space-y-2">
      <H2>2. Erhebung und Verarbeitung personenbezogener Daten</H2>
      <p>
        Wir verarbeiten personenbezogene Daten nur, soweit dies zur Bereitstellung dieser Website
        sowie zur Bearbeitung Ihrer Anfragen erforderlich ist. Rechtsgrundlage ist Art. 6 Abs. 1
        lit. b und f DSGVO.
      </p>
    </section>

    <section className="space-y-2">
      <H2>3. Kontakt- und Terminanfrageformular</H2>
      <p>
        Wenn Sie uns über das Anfrageformular kontaktieren, werden die von Ihnen angegebenen Daten
        (Name, E-Mail, Telefon, gewünschte Leistung, Wunschtermin, Adresse für den Hausbesuch sowie
        Ihre Nachricht) zum Zweck der Bearbeitung Ihrer Anfrage und zur Terminabstimmung gespeichert
        und per E-Mail an uns übermittelt. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
      </p>
    </section>

    <section className="space-y-2">
      <H2>4. Gesundheitsdaten</H2>
      <p>
        Sofern Sie in Ihrer Anfrage Angaben zu Beschwerden oder Ihrem Gesundheitszustand machen,
        handelt es sich um besondere Kategorien personenbezogener Daten (Art. 9 DSGVO). Die
        Verarbeitung erfolgt ausschließlich zur Vorbereitung und Durchführung der physiotherapeutischen
        Behandlung auf Grundlage Ihrer Einwilligung bzw. Art. 9 Abs. 2 lit. h DSGVO.
      </p>
    </section>

    <section className="space-y-2">
      <H2>5. Speicherdauer</H2>
      <p>
        Wir speichern personenbezogene Daten nur so lange, wie dies für die genannten Zwecke oder
        aufgrund gesetzlicher Aufbewahrungsfristen erforderlich ist. Anschließend werden die Daten
        gelöscht.
      </p>
    </section>

    <section className="space-y-2">
      <H2>6. Ihre Rechte</H2>
      <p>
        Sie haben das Recht auf Auskunft (Art. 15), Berichtigung (Art. 16), Löschung (Art. 17),
        Einschränkung der Verarbeitung (Art. 18), Datenübertragbarkeit (Art. 20) sowie Widerspruch
        (Art. 21 DSGVO). Zudem können Sie sich bei einer Datenschutz-Aufsichtsbehörde beschweren.
        Eine erteilte Einwilligung können Sie jederzeit mit Wirkung für die Zukunft widerrufen.
      </p>
    </section>

    <section className="space-y-2">
      <H2>7. Hosting</H2>
      <p>
        Diese Website wird bei einem Dienstleister gehostet. Dabei können technisch notwendige Daten
        (z. B. IP-Adresse, Zugriffszeitpunkt) in Server-Logfiles verarbeitet werden. Rechtsgrundlage
        ist unser berechtigtes Interesse an einem sicheren und stabilen Betrieb (Art. 6 Abs. 1 lit. f DSGVO).
      </p>
      <p className="text-neutral-500 text-sm">
        [Bitte ergänzen: Name und Anschrift des Hosting-Anbieters, ggf. Auftragsverarbeitungsvertrag.]
      </p>
    </section>
  </Shell>
);
